export default "__VITE_ASSET__DIMzWjPr__"